import gsap from 'gsap';

// Animação de entrada/saída dos overlays do PrimeVue (painel do Dropdown, MultiSelect, etc).
// Entra no lugar da transição CSS 'p-connected-overlay': é aplicada pela seção 'transition'
// do Pass Through, com css: false para desligar as classes do PrimeVue e deixar o GSAP no controle.

const DURACAO_ENTRADA = 0.22;
const DURACAO_SAIDA = 0.12;

const semMovimento = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const transicaoOverlay = {
  css: false,
  onEnter: (el, done) => {
    gsap.killTweensOf(el);

    if (semMovimento()) {
      done();
      return;
    }

    gsap.fromTo(
      el,
      { opacity: 0, y: -8, scaleY: 0.96 },
      {
        opacity: 1,
        y: 0,
        scaleY: 1,
        duration: DURACAO_ENTRADA,
        ease: 'power3.out',
        transformOrigin: 'top center',
        // O PrimeVue posiciona o painel por top/left; devolver o transform evita
        // que o elemento continue criando um containing block depois da animação
        clearProps: 'transform',
        onComplete: done,
        onInterrupt: done,
      }
    );
  },
  onLeave: (el, done) => {
    gsap.killTweensOf(el);

    if (semMovimento()) {
      done();
      return;
    }

    gsap.to(el, {
      opacity: 0,
      y: -6,
      scaleY: 0.98,
      duration: DURACAO_SAIDA,
      ease: 'power2.in',
      transformOrigin: 'top center',
      onComplete: done,
      onInterrupt: done,
    });
  },
};
